import {Http} from '@/model/Http.js'

export default class AddPriceApi extends Http {

	// 开关显示
	markUpFind(data) {
		const url = '/movie/open/open-movie-app-append/find'
		return this.postAjaxByMini(url, data)
	}

	// 更新开关
	updateMarkUpSwitch(data) {
		const url = '/movie/open/open-movie-app-append/update-markup-switch'
		return this.postAjaxByMini(url, data)
	}

	// 添加修改影院分类
	marketAddUpdate(data) {
		const url = '/movie/open/open-app-markup-append/add-update'
		return this.postAjaxByMini(url, data)
	}

	// 删除影院分类
	marketDel(data) {
		const url = '/movie/open/open-app-markup-append/del'
		return this.postAjaxByMini(url, data)
	}

	// 是否关闭优惠显示
	updateDisplayDiscounts(data) {
		const url = '/movie/open/open-movie-app-append/update-display-discounts'
		return this.postAjaxByMini(url, data)
	}

	// 获取所有影院分类
	queryCinemaClassify(data) {
		const url = '/movie/open/open-app-markup-append/query-cinema-classify'
		return this.postAjaxByMini(url, data)
	}
  
  // 获取影院分类
  getCinemaClassify(data) {
    const url = '/nezha-open-movie/virtual-markup/category/ds'
    return this.getGateway(url, data)
  }
  
  // 查询虚拟加价规则
  getMarkUpRules({id}) {
    const url = `/nezha-open-movie/virtual-markup/rule/list/${id}`
    return this.getGateway(url, {})
  }
  
  // 保存虚拟加价规则
  saveMarkUpRules(data,{id}) {
    const url = `/nezha-open-movie/virtual-markup/rule/batch-del-save/${id}`
    return this.postGateway(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/api/addPrice.js